<template>
    <div class="uk-width-large uk-container uk-container-center uk-tile" v-if="tokenStatus">
        <p style="text-align: center">以下の項目を入力すると本登録が完了します。</p>
        <form class="padding-medium uk-border-rounded border-muted uk-background-default uk-box-shadow-small" @submit.prevent="register">
            <div v-if="registerErrors" class="uk-form-danger">
                <ul v-if="registerErrors.name">
                    <li v-for="msg in registerErrors.name" :key="msg">{{ msg }}</li>
                </ul>
                <ul v-if="registerErrors.password">
                    <li v-for="msg in registerErrors.password" :key="msg">{{ msg }}</li>
                </ul>
            </div>
            <div class="uk-margin">
                <label class="uk-form-label" for="invite-email">名前</label>
                <div class="uk-position-relative">
                    <span class="uk-form-icon" uk-icon="icon: user"></span>
                    <input type="text" class="uk-input" id="invite-email" v-model="registerForm.name">
                </div>
            </div>

            <div class="uk-margin">
                <label class="uk-form-label" for="password">Password</label>
                <div class="uk-position-relative">
                    <span class="uk-form-icon" uk-icon="icon: lock"></span>
                    <input type="password" class="uk-input" id="password" v-model="registerForm.password">
                </div>
            </div>

            <div class="uk-margin">
                <label class="uk-form-label" for="password-confirmation">Password (confirm)</label>
                <div class="uk-position-relative">
                    <span class="uk-form-icon" uk-icon="icon: lock"></span>
                    <input type="password" class="uk-input" id="password-confirmation" v-model="registerForm.password_confirmation">
                </div>
            </div>

            <div class="">
                <button type="submit" class="uk-width-1-1 uk-button uk-button-primary">{{ button.register }}</button>
            </div>
        </form>
    </div>

    <div class="uk-width-large uk-container uk-container-center uk-tile" v-else="tokenStatus===false">
        <p style="text-align: center">{{tokenError}}</p>
    </div>

</template>

<script>
export default {
    data () {
        return {
            tab: 1,
            registerForm: {
                name: '',
                password: '',
                password_confirmation: ''
            },
            button: {
                register: ''
            },
            tokenError: null
        }
    },
    computed: {
        token () {
            return this.$store.state.auth.token
        },
        tempRegisterStatus () {
            return this.$store.state.invite.tempInviteStatus
        },
        registerErrors() {
            return this.$store.state.auth.registerErrorMessages
        },
        tokenStatus() {
            return this.$store.state.invite.tokenStatus
        },
        inviteToken() {
            const path = this.$route.path.split('/')
            return path[3]
        },
        apiStatus () {
            return this.$store.state.auth.apiStatus
        },
    },
    methods: {
        async checkInviteToken () {
            await this.$store.dispatch('invite/checkInviteToken', {'token': this.inviteToken})

            if (! this.tokenStatus) {
                // tokenの認証失敗
                this.tokenError = '認証に失敗しました。再度招待を受けてください。'
            }
        },
        async register() {
            this.button.register = '...'
            const data = this.registerForm
            data['token'] = this.inviteToken
            await this.$store.dispatch('auth/completeInviteRegister', data)

            if (this.apiStatus) {
                // トップページに移動する
                this.$router.push('/')
            }

            this.setButtonText()
        },
        clearError () {
            this.$store.commit('auth/setLoginErrorMessages', null)
        },
        setButtonText() {
            this.button.register = 'register'
        }
    },
    created () {
        this.checkInviteToken()
        this.clearError()
        this.setButtonText()
    }
}
</script>